import React from 'react';
import clsx from 'clsx';
import './index.scss';

const CheckBoxInput = ({ value, onChange, checked, label, id }) => {
  return (
    <label htmlFor={id}>
      <div className={clsx('CheckBoxInput', { checked })}>
        <input
          type="checkbox"
          value={value}
          onChange={onChange}
          checked={checked}
          id={id}
        />
        {label}
      </div>
    </label>
  );
};

export default CheckBoxInput;